module.exports = __webpack_public_path__ + "img/adSearch.c6d3c935.svg";